export default "__VITE_ASSET__LtBM36mR__"